import React from 'react';

function Step2({ recipient, onRecipientChange }) {
  const onChange = (field, value) => {
    onRecipientChange({ ...recipient, [field]: value })
  }

  return (
    <section className="step">
      <div className="mb-4">
          <h5 className="widget-title text-center">Krok 2/3: Twoje dane</h5>
          <div className="progress" style={{ height: '8px' }}>
              <div className="progress-bar position-relative bg-primary" style={{ width: '66%' }}></div>
          </div>
      </div>

      <div>
        <div className="form-group mb-3">
          <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label> 
          <input type="email" id="email" value={recipient.email} onChange={e => onChange('email', e.target.value)} className="form-control" />
          {/* <input name="email" type="email" id="email" v-model="recipient.email" :className="{'is-invalid': errors.email, 'form-control': true}"> */}
          <small className="text-muted">Na podany adres zostanie wysłane potwierdzenie spływu.</small>
        </div>
        <div className="form-group mb-3">
          <label htmlFor="fname" className="form-label">Imię <span className="text-danger">*</span></label>
          <input type="text" id="fname" value={recipient.firstName} onChange={e => onChange('firstName', e.target.value)} className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="lname" className="form-label">Nazwisko <span className="text-danger">*</span></label>
          <input type="text" id="lname" value={recipient.lastName} onChange={e => onChange('lastName', e.target.value)} className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label htmlFor="phone" className="form-label">Telefon kontaktowy <span className="text-danger">*</span></label>
          <input type="text" id="phone"value={recipient.phone} onChange={e => onChange('phone', e.target.value)} className="form-control" />
          <small className="text-muted">Podaj swój telefon abyśmy mogli się z Tobą skontaktować w razie nieoczekiwanych sytuacji.</small>
        </div>

      </div>
    </section>
  );
}

export default Step2;
